"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cybertronicsMethods = exports.bizoneMethods = exports.facctMethods = void 0;
var methodsFactory = function (provider) {
    // Будут вызваны после загрузки скрипта
    var methodsToCall = [];
    var addMethodToCall = function (callMethod) {
        methodsToCall.push(callMethod);
    };
    return {
        methodsToCall: methodsToCall,
        addMethodToCall: addMethodToCall,
    };
};
exports.facctMethods = methodsFactory("facct");
exports.bizoneMethods = methodsFactory("bizone");
exports.cybertronicsMethods = methodsFactory("cybertronics");
//# sourceMappingURL=methods-to-call.js.map